export const frSeasonMetaDesc = [
	{
		conditions: {
			title: {
				lt: 13,
			},
			provider: {
				lte: 7,
			},
		},
		v1_translatable:
			'{{titleName}} est en streaming sur {{providerNames}}. Regardez tous les épisodes avec options VF, VOSTFR, gratuit et 4K.',
		v1_max_length: 119,
		v2_translatable:
			'Regardez {{titleName}} légalement en ligne sur {{providerNames}}. Tous les épisodes sont disponibles avec les options VF, VOSTFR, gratuit et 4K.',
		v2_max_length: 143,
		v3_translatable:
			'Regardez {{titleName}} légalement en ligne sur {{providerNames}}. Tous les épisodes disponibles. Options de streaming mises à jour le {{lastUpdatedAt}}.',
		v3_max_length: 155,
	},
	{
		conditions: {
			title: {
				lt: 13,
			},
			provider: {
				lte: 15,
			},
		},
		v1_translatable:
			'{{titleName}} est en streaming sur {{providerNames}}. Regardez tous les épisodes avec options VF, VOSTFR, gratuit et 4K.',
		v1_max_length: 127,
		v2_translatable:
			'Regardez {{titleName}} légalement en ligne sur {{providerNames}}. Tous les épisodes sont disponibles avec les options VF, VOSTFR, gratuit et 4K.',
		v2_max_length: 150,
		v3_translatable:
			'Regardez {{titleName}} légalement en ligne sur {{providerNames}}. Épisodes disponibles. Options de streaming mises à jour le {{lastUpdatedAt}}.',
		v3_max_length: 152,
	},
	{
		conditions: {
			title: {
				lt: 13,
			},
			provider: {
				lte: 21,
			},
		},
		v1_translatable:
			'{{titleName}} est en streaming sur {{providerNames}}. Regardez tous les épisodes avec options VF, VOSTFR, gratuit et 4K.',
		v1_max_length: 131,
		v2_translatable:
			'Regardez {{titleName}} légalement en ligne sur {{providerNames}}. Tous les épisodes sont disponibles avec les options VF, VOSTFR, gratuit et 4K.',
		v2_max_length: 155,
		v3_translatable:
			'Regardez {{titleName}} légalement en ligne sur {{providerNames}}. Options de streaming mises à jour le  {{lastUpdatedAt}}.',
		v3_max_length: 136,
	},
	{
		conditions: {
			title: {
				lt: 13,
			},
			provider: {
				lte: 30,
			},
		},
		v1_translatable:
			'{{titleName}} est en streaming sur {{providerNames}}. Regardez tous les épisodes avec options VF, VOSTFR, gratuit et 4K.',
		v1_max_length: 141,
		v2_translatable:
			'Regardez {{titleName}} légalement en ligne sur {{providerNames}}. Tous les épisodes sont disponibles en options VF, VOSTFR et gratuit.',
		v2_max_length: 155,
		v3_translatable:
			'Regardez {{titleName}} légalement en ligne sur {{providerNames}}. Options de streaming mises à jour le {{lastUpdatedAt}}.',
		v3_max_length: 145,
	},
	{
		conditions: {
			title: {
				lt: 13,
			},
			provider: {
				lte: 40,
			},
		},
		v1_translatable:
			'{{titleName}} est en streaming sur {{providerNames}}. Regardez tous les épisodes avec options VF, VOSTFR, gratuit et 4K.',
		v1_max_length: 149,
		v2_translatable:
			'Regardez {{titleName}} légalement en ligne sur {{providerNames}}. Tous les épisodes sont disponibles en VF, VOSTFR et gratuit.',
		v2_max_length: 156,
		v3_translatable:
			'Regardez {{titleName}} légalement en ligne sur {{providerNames}}. Options de streaming mises à jour le {{lastUpdatedAt}}.',
		v3_max_length: 153,
	},
	{
		conditions: {
			title: {
				lt: 13,
			},
			provider: {
				gt: 40,
			},
			restCount: {
				eq: 1,
			},
		},
		v1_translatable:
			'{{titleName}} est en streaming sur {{providerNames}}, avec 1 autre service. Épisodes en VF, VOSTFR, gratuit et 4K.',
		v1_max_length: 146,
		v2_translatable:
			'Regardez {{titleName}} légalement en ligne sur {{providerNames}}, et 1 autre service. Épisodes en VF, VOSTFR et gratuit.',
		v2_max_length: 152,
		v3_translatable:
			'Regardez {{titleName}} légalement en ligne sur {{providerNames}}, avec 1 autre service. Mis à jour le {{lastUpdatedAt}}.',
		v3_max_length: 155,
	},
	{
		conditions: {
			title: {
				lt: 13,
			},
			provider: {
				gt: 40,
			},
			restCount: {
				gt: 1,
			},
		},
		v1_translatable:
			'{{titleName}} est en streaming sur {{providerNames}}, avec {{restCount}} autres services. Épisodes en VF, VOSTFR, gratuit et 4K.',
		v1_max_length: 152,
		v2_translatable:
			'Regardez {{titleName}} légalement en ligne sur {{providerNames}}, et {{restCount}} autres services. Épisodes en VF et gratuit.',
		v2_max_length: 150,
		v3_translatable:
			'Regardez {{titleName}} légalement en ligne sur {{providerNames}}, avec {{restCount}} autres services. Mis à jour : {{lastUpdatedAt}}.',
		v3_max_length: 160,
	},
	{
		conditions: {
			title: {
				lt: 22,
			},
			provider: {
				lte: 7,
			},
		},
		v1_translatable:
			'{{titleName}} est en streaming sur {{providerNames}}. Regardez tous les épisodes avec options VF, VOSTFR, gratuit et 4K.',
		v1_max_length: 128,
		v2_translatable:
			'Regardez {{titleName}} légalement en ligne sur {{providerNames}}. Tous les épisodes sont disponibles avec options VF, VOSTFR, gratuit et 4K.',
		v2_max_length: 148,
		v3_translatable:
			'Regardez {{titleName}} légalement en ligne sur {{providerNames}}. Épisodes disponibles. Options de streaming mises à jour le {{lastUpdatedAt}}.',
		v3_max_length: 155,
	},
	{
		conditions: {
			title: {
				lt: 22,
			},
			provider: {
				lte: 15,
			},
		},
		v1_translatable:
			'{{titleName}} est en streaming sur {{providerNames}}. Regardez tous les épisodes avec options VF, VOSTFR, gratuit et 4K.',
		v1_max_length: 135,
		v2_translatable:
			'Regardez {{titleName}} légalement en ligne sur {{providerNames}}. Tous les épisodes sont disponibles avec options VF, VOSTFR, gratuit et 4K.',
		v2_max_length: 155,
		v3_translatable:
			'Regardez {{titleName}} légalement en ligne sur {{providerNames}}. Épisodes disponibles. Mis à jour le {{lastUpdatedAt}}.',
		v3_max_length: 138,
	},
	{
		conditions: {
			title: {
				lt: 22,
			},
			provider: {
				lte: 21,
			},
		},
		v1_translatable:
			'{{titleName}} est en streaming sur {{providerNames}}. Regardez tous les épisodes avec options VF, VOSTFR, gratuit et 4K.',
		v1_max_length: 140,
		v2_translatable:
			'Regardez {{titleName}} légalement en ligne sur {{providerNames}}. Tous les épisodes sont disponibles avec options VF, VOSTFR et gratuit.',
		v2_max_length: 156,
		v3_translatable:
			'Regardez {{titleName}} légalement en ligne sur {{providerNames}}. Épisodes disponibles. Mis à jour le {{lastUpdatedAt}}.',
		v3_max_length: 143,
	},
	{
		conditions: {
			title: {
				lt: 22,
			},
			provider: {
				lte: 30,
			},
		},
		v1_translatable:
			'{{titleName}} est en streaming sur {{providerNames}}. Regardez tous les épisodes avec options VF, VOSTFR, gratuit et 4K.',
		v1_max_length: 150,
		v2_translatable:
			'Regardez {{titleName}} légalement en ligne sur {{providerNames}}. Tous les épisodes sont disponibles avec options VF et gratuit.',
		v2_max_length: 158,
		v3_translatable:
			'Regardez {{titleName}} légalement en ligne sur {{providerNames}}. Épisodes disponibles. Mis à jour le {{lastUpdatedAt}}.',
		v3_max_length: 153,
	},
	{
		conditions: {
			title: {
				lt: 22,
			},
			provider: {
				lte: 40,
			},
		},
		v1_translatable:
			'{{titleName}} est en streaming sur {{providerNames}}. Regardez tous les épisodes avec options VF, VOSTFR, gratuit et 4K.',
		v1_max_length: 158,
		v2_translatable:
			'Regardez {{titleName}} légalement en ligne sur {{providerNames}}. Tous les épisodes en VF, VOSTFR et gratuit.',
		v2_max_length: 147,
		v3_translatable:
			'Regardez {{titleName}} légalement en ligne sur {{providerNames}}. Mis à jour le {{lastUpdatedAt}}.',
		v3_max_length: 139,
	},
	{
		conditions: {
			title: {
				lt: 22,
			},
			provider: {
				gt: 40,
			},
			restCount: {
				eq: 1,
			},
		},
		v1_translatable:
			'{{titleName}} est en streaming sur {{providerNames}}, et 1 autre service. Épisodes en VF, VOSTFR, gratuit et 4K.',
		v1_max_length: 153,
		v2_translatable:
			'Regardez {{titleName}} légalement en ligne sur {{providerNames}}, et 1 autre service. Épisodes en VF et gratuit.',
		v2_max_length: 153,
		v3_translatable:
			'Regardez {{titleName}} légalement en ligne sur {{providerNames}}, et 1 autre. Mis à jour le {{lastUpdatedAt}}.',
		v3_max_length: 154,
	},
	{
		conditions: {
			title: {
				lt: 22,
			},
			provider: {
				gt: 40,
			},
			restCount: {
				gt: 1,
			},
		},
		v1_translatable:
			'{{titleName}} est en streaming sur {{providerNames}}, et {{restCount}} autres services. Épisodes en VF et gratuit.',
		v1_max_length: 147,
		v2_translatable:
			'Regardez {{titleName}} légalement en ligne sur {{providerNames}}, et {{restCount}} autres services. En VF et gratuit.',
		v2_max_length: 151,
		v3_translatable:
			'Regardez {{titleName}} légalement en ligne sur {{providerNames}}, et {{restCount}} autres. Mis à jour le {{lastUpdatedAt}}.',
		v3_max_length: 160,
	},
	{
		conditions: {
			title: {
				lt: 33,
			},
			provider: {
				lte: 7,
			},
		},
		v1_translatable:
			'{{titleName}} est en streaming sur {{providerNames}}. Regardez tous les épisodes avec options VF, VOSTFR, gratuit et 4K.',
		v1_max_length: 139,
		v2_translatable:
			'Regardez {{titleName}} légalement en ligne sur {{providerNames}}. Tous les épisodes sont disponibles avec options VF, VOSTFR et gratuit.',
		v2_max_length: 155,
		v3_translatable:
			'Regardez {{titleName}} légalement en ligne sur {{providerNames}}. Épisodes disponibles. Mis à jour le {{lastUpdatedAt}}.',
		v3_max_length: 142,
	},
	{
		conditions: {
			title: {
				lt: 33,
			},
			provider: {
				lte: 15,
			},
		},
		v1_translatable:
			'{{titleName}} est en streaming sur {{providerNames}}. Regardez tous les épisodes en VF, VOSTFR, gratuit et 4K.',
		v1_max_length: 136,
		v2_translatable:
			'Regardez {{titleName}} légalement en ligne sur {{providerNames}}. Tous les épisodes sont disponibles avec options VF et gratuit.',
		v2_max_length: 154,
		v3_translatable:
			'Regardez {{titleName}} légalement en ligne sur {{providerNames}}. Épisodes disponibles. Mis à jour le {{lastUpdatedAt}}.',
		v3_max_length: 149,
	},
	{
		conditions: {
			title: {
				lt: 33,
			},
			provider: {
				lte: 21,
			},
		},
		v1_translatable:
			'{{titleName}} est en streaming sur {{providerNames}}.Regardez tous les épisodes en VF, VOSTFR, gratuit et 4K.',
		v1_max_length: 140,
		v2_translatable:
			'Regardez {{titleName}} légalement en ligne sur {{providerNames}}. Tous les épisodes avec options VF et gratuit.',
		v2_max_length: 142,
		v3_translatable:
			'Regardez {{titleName}} légalement en ligne sur {{providerNames}}. Épisodes disponibles. Mis à jour le {{lastUpdatedAt}}.',
		v3_max_length: 154,
	},
	{
		conditions: {
			title: {
				lt: 33,
			},
			provider: {
				lte: 30,
			},
		},
		v1_translatable:
			'{{titleName}} est en streaming sur {{providerNames}}. Regardez tous les épisodes en VF, VOSTFR, gratuit et 4K.',
		v1_max_length: 151,
		v2_translatable:
			'Regardez {{titleName}} légalement en ligne sur {{providerNames}}. Tous les épisodes disponibles en options VF et gratuit.',
		v2_max_length: 162,
		v3_translatable:
			'Regardez {{titleName}} légalement en ligne sur {{providerNames}}. Mis à jour le {{lastUpdatedAt}}.',
		v3_max_length: 142,
	},
	{
		conditions: {
			title: {
				lt: 33,
			},
			provider: {
				lte: 40,
			},
		},
		v1_translatable:
			'{{titleName}} est en streaming sur {{providerNames}}. Regardez tous les épisodes en VF, VOSTFR et gratuit.',
		v1_max_length: 155,
		v2_translatable:
			'Regardez {{titleName}} légalement en ligne sur {{providerNames}}. Tous les épisodes en VF, VOSTFR et gratuit.',
		v2_max_length: 158,
		v3_translatable:
			'Regardez {{titleName}} légalement en ligne sur {{providerNames}}. Mis à jour le {{lastUpdatedAt}}.',
		v3_max_length: 150,
	},
	{
		conditions: {
			title: {
				lt: 33,
			},
			provider: {
				gt: 40,
			},
			restCount: {
				eq: 1,
			},
		},
		v1_translatable:
			'{{titleName}} est en streaming sur {{providerNames}}, et 1 autre service. Épisodes en VF et gratuit.',
		v1_max_length: 152,
		v2_translatable:
			'Regardez {{titleName}} légalement en ligne sur {{providerNames}}, et 1 autre service. En VF et gratuit.',
		v2_max_length: 155,
		v3_translatable:
			'Regardez {{titleName}} légalement en ligne sur {{providerNames}}, et 1 autre service. Tous les épisodes.',
		v3_max_length: 156,
	},
	{
		conditions: {
			title: {
				lt: 33,
			},
			provider: {
				gt: 40,
			},
			restCount: {
				gt: 1,
			},
		},
		v1_translatable:
			'{{titleName}} est en streaming sur {{providerNames}}, et {{restCount}} autres services. En VF et gratuit.',
		v1_max_length: 149,
		v2_translatable:
			'Regardez {{titleName}} légalement en ligne sur {{providerNames}}, et {{restCount}} autres services. VF & gratuit.',
		v2_max_length: 157,
		v3_translatable:
			'Regardez {{titleName}} légalement en ligne sur {{providerNames}}, et {{restCount}} autres services.',
		v3_max_length: 144,
	},
	{
		conditions: {
			title: {
				lt: 53,
			},
			provider: {
				lte: 7,
			},
		},
		v1_translatable:
			'{{titleName}} est en streaming sur {{providerNames}}. Regardez tous les épisodes en VF, VOSTFR, gratuit et 4K.',
		v1_max_length: 149,
		v2_translatable:
			'Regardez {{titleName}} légalement en ligne sur {{providerNames}}. Tous les épisodes en VF, VOSTFR et gratuit.',
		v2_max_length: 148,
		v3_translatable:
			'Regardez {{titleName}} légalement en ligne sur {{providerNames}}. Mis à jour le {{lastUpdatedAt}}.',
		v3_max_length: 141,
	},
	{
		conditions: {
			title: {
				lt: 53,
			},
			provider: {
				lte: 15,
			},
		},
		v1_translatable:
			'{{titleName}} est en streaming sur {{providerNames}}. Regardez tous les épisodes en VF, VOSTFR et gratuit.',
		v1_max_length: 152,
		v2_translatable:
			'Regardez {{titleName}} légalement en ligne sur {{providerNames}}. Tous les épisodes en VF et gratuit.',
		v2_max_length: 147,
		v3_translatable:
			'Regardez {{titleName}} légalement en ligne sur {{providerNames}}. Mis à jour le {{lastUpdatedAt}}.',
		v3_max_length: 147,
	},
	{
		conditions: {
			title: {
				lt: 53,
			},
			provider: {
				lte: 21,
			},
		},
		v1_translatable:
			'{{titleName}} est en streaming sur {{providerNames}}. Tous les épisodes en VF, VOSTFR, gratuit et 4K.',
		v1_max_length: 152,
		v2_translatable:
			'Regardez {{titleName}} légalement en ligne sur {{providerNames}}. Tous les épisodes en VF et gratuit.',
		v2_max_length: 152,
		v3_translatable:
			'Regardez {{titleName}} légalement en ligne sur {{providerNames}}. Mis à jour le {{lastUpdatedAt}}.',
		v3_max_length: 152,
	},
	{
		conditions: {
			title: {
				lt: 53,
			},
			provider: {
				lte: 30,
			},
		},
		v1_translatable: '{{titleName}} est en streaming sur {{providerNames}}. Tous les épisodes en VF et gratuit.',
		v1_max_length: 150,
		v2_translatable: 'Regardez {{titleName}} légalement en ligne sur {{providerNames}}. Épisodes en VF et gratuit.',
		v2_max_length: 153,
		v3_translatable: 'Regardez {{titleName}} en ligne sur {{providerNames}}. Mis à jour le {{lastUpdatedAt}}.',
		v3_max_length: 151,
	},
	{
		conditions: {
			title: {
				lt: 53,
			},
			provider: {
				lte: 40,
			},
		},
		v1_translatable: '{{titleName}} est en streaming sur {{providerNames}}. Épisodes en VF et gratuit.',
		v1_max_length: 149,
		v2_translatable: 'Regardez {{titleName}} légalement en ligne sur {{providerNames}}. En VF et gratuit.',
		v2_max_length: 152,
		v3_translatable: 'Regardez {{titleName}} sur {{providerNames}}. Mis à jour le {{lastUpdatedAt}}.',
		v3_max_length: 150,
	},
	{
		conditions: {
			title: {
				lt: 53,
			},
			provider: {
				gt: 40,
			},
			restCount: {
				eq: 1,
			},
		},
		v1_translatable: '{{titleName}} est en streaming sur {{providerNames}}, et 1 autre service. En VF.',
		v1_max_length: 152,
		v2_translatable: 'Regardez {{titleName}} légalement en ligne sur {{providerNames}}, et 1 autre service.',
		v2_max_length: 157,
		v3_translatable: 'Regardez {{titleName}} sur {{providerNames}}, et 1 autre. Mis à jour le {{lastUpdatedAt}}.',
		v3_max_length: 165,
	},
	{
		conditions: {
			title: {
				lt: 53,
			},
			provider: {
				gt: 40,
			},
			restCount: {
				gt: 1,
			},
		},
		v1_translatable:
			'{{titleName}} est en streaming sur {{providerNames}}, et {{restCount}} autres services. En VF.',
		v1_max_length: 158,
		v2_translatable: 'Regardez {{titleName}} légalement en ligne sur {{providerNames}}, et {{restCount}} autres.',
		v2_max_length: 154,
		v3_translatable: '{{titleName}} en ligne sur {{providerNames}}, avec {{restCount}} autres services.',
		v3_max_length: 145,
	},
	{
		conditions: {
			title: {
				gt: 52,
			},
			provider: {
				lte: 7,
			},
		},
		v1_translatable:
			'{{titleName}} est en streaming sur {{providerNames}}. Tous les épisodes en VF, VOSTFR, gratuit et 4K.',
		v1_max_length: 148,
		v2_translatable:
			'Regardez {{titleName}} légalement en ligne sur {{providerNames}}. Tous les épisodes en VF et gratuit.',
		v2_max_length: 148,
		v3_translatable:
			'Regardez {{titleName}} légalement en ligne sur {{providerNames}}. Mis à jour le {{lastUpdatedAt}}.',
		v3_max_length: 148,
	},
	{
		conditions: {
			title: {
				gt: 52,
			},
			provider: {
				lte: 15,
			},
		},
		v1_translatable:
			'{{titleName}} est en streaming sur {{providerNames}}. Tous les épisodes en VF, VOSTFR et gratuit.',
		v1_max_length: 151,
		v2_translatable:
			'Regardez {{titleName}} légalement en ligne sur {{providerNames}}. Tous les épisodes en VF et gratuit.',
		v2_max_length: 155,
		v3_translatable:
			'Regardez {{titleName}} légalement en ligne sur {{providerNames}}. Mis à jour le {{lastUpdatedAt}}.',
		v3_max_length: 155,
	},
	{
		conditions: {
			title: {
				gt: 52,
			},
			provider: {
				lte: 21,
			},
		},
		v1_translatable: '{{titleName}} est en streaming sur {{providerNames}}. Épisodes en VF, VOSTFR et gratuit.',
		v1_max_length: 147,
		v2_translatable: 'Regardez {{titleName}} légalement en ligne sur {{providerNames}}. Épisodes en VF et gratuit.',
		v2_max_length: 151,
		v3_translatable:
			'Regardez {{titleName}} légal en ligne sur {{providerNames}}. Mis à jour le {{lastUpdatedAt}}.',
		v3_max_length: 155,
	},
	{
		conditions: {
			title: {
				gt: 52,
			},
			provider: {
				lte: 30,
			},
		},
		v1_translatable: '{{titleName}} est en streaming sur {{providerNames}}. Épisodes en VF et gratuit.',
		v1_max_length: 149,
		v2_translatable: 'Regardez {{titleName}} légalement en ligne sur {{providerNames}}. En VF et gratuit.',
		v2_max_length: 152,
		v3_translatable: 'Regardez {{titleName}} sur {{providerNames}}. Mis à jour le {{lastUpdatedAt}}.',
		v3_max_length: 150,
	},
	{
		conditions: {
			title: {
				gt: 52,
			},
			provider: {
				lte: 40,
			},
		},
		v1_translatable: '{{titleName}} est en streaming sur {{providerNames}}. Épisodes en VF, gratuit.',
		v1_max_length: 155,
		v2_translatable: 'Regardez {{titleName}} légalement en ligne sur {{providerNames}}.',
		v2_max_length: 143,
		v3_translatable: 'Regardez {{titleName}} sur {{providerNames}}. Mis à jour le {{lastUpdatedAt}}.',
		v3_max_length: 156,
	},
	{
		conditions: {
			title: {
				gt: 52,
			},
			provider: {
				gt: 40,
			},
			restCount: {
				eq: 1,
			},
		},
		v1_translatable: '{{titleName}} est en streaming sur {{providerNames}}, et 1 autre service.',
		v1_max_length: 153,
		v2_translatable: 'Regardez {{titleName}} en ligne sur {{providerNames}}, et 1 autre service.',
		v2_max_length: 154,
		v3_translatable: 'Regardez {{titleName}} sur {{providerNames}}, et 1 autre service.',
		v3_max_length: 143,
	},
	{
		conditions: {
			title: {
				gt: 52,
			},
			provider: {
				gt: 40,
			},
			restCount: {
				gt: 1,
			},
		},
		v1_translatable: '{{titleName}} est en streaming sur {{providerNames}}, et {{restCount}} autres services.',
		v1_max_length: 159,
		v2_translatable: 'Regardez {{titleName}} en ligne sur {{providerNames}}, et {{restCount}} autres.',
		v2_max_length: 151,
		v3_translatable: 'Regardez {{titleName}} en ligne sur {{providerNames}}, et {{restCount}} autres services.',
		v3_max_length: 158,
	},
];
